import wppIcon from '../../assets/images/wpp.png'
import styles from './IconeZapZap.module.scss'
import { openWhatsApp } from '../../whatsapp'

// Usa openWhatsApp em vez de abrir a URL por conta própria: este é o CTA mais
// visível da página (fica fixo na tela o tempo todo) e antes ficava de fora da
// medição de conversão, além de manter uma segunda cópia da URL do WhatsApp.
const IconeZapZap = () => (
  <img
    onClick={openWhatsApp}
    className={styles.iconezap}
    src={wppIcon}
    alt="Ícone do whatsapp que treme um pouco"
  />
)

export default IconeZapZap
